export const clickOutsideNested = {
    mounted(el, binding) {
        el._clickOutsideNested = (event) => {
            // Check if click was outside the element and its children
            if (!(el === event.target || el.contains(event.target))) {
                // Additional checks for nested components that shouldn't trigger close
                const clickedElement = event.target;
                
                // Check if the clicked element is within specific nested form controls
                const isWithinFormControl = clickedElement.closest(
                    '.zs-dropdown-container, .zs-date-picker, .zs-dropdown-menu, .picker-holder, .filter-header'
                );
                
                // Check if this nested form control is within our dropdown
                if (isWithinFormControl) {
                    const ourDropdownMenu = el.querySelector('.dropdown-menu');
                    if (ourDropdownMenu && ourDropdownMenu.contains(isWithinFormControl)) {
                        // Don't close if clicking within our own nested components
                        return;
                    }
                }
                
                // Call the provided function for truly outside clicks
                binding.value(event);
            }
        };
        document.addEventListener('click', el._clickOutsideNested, true); // Use capture phase
    },
    unmounted(el) {
        // Clean up the event listener
        document.removeEventListener('click', el._clickOutsideNested, true);
        delete el._clickOutsideNested;
    }
};
